import React, { Component, createRef } from 'react';
import moment from 'moment';
import Select from 'react-select';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage } from '../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { MESSAGE_STATUS_CONSTANT } from '../../constants/messageStatusConstant';
import { MESSAGE_TYPE_CONSTANT } from '../../constants/messageTypeConstant';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_ESCALATE_UPDATE_ASSIGNEE } from '../../constants/menuPermissionConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import API_CHAT from '../../api/apiChat';
import IconAlertWarning from '../../assets/images/AlertWarning.svg';
import ActionType from '../../redux/reducer/globalActionType';
import Alert from '../Alert/Alert';

class TicketEscalation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showEscalationModal: false,
            showEscalationLead: false,
            showEscalationAction: false,
            escalation: [
                {
                    id: 1,
                    type: "Eskalasi ke CS Lain"
                },
                {
                    id: 2,
                    type: "Eskalasi ke Bug Validator"
                },
                {
                    id: 3,
                    type: "Eskalasi ke Pihak Ketiga"
                },
                {
                    id: 4,
                    type: "Eskalasi ke CS Lead"
                }
            ],
            selectedEscalation: 0,
            escalationReason: '',
            escalationReasonOption: {
                data: [],
                value: ''
            },
            lastVectorX: 0,
            lastVectorY: 0,
            isAssignBySystem: true,
            isAssignByUser: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleEscalation = () => {
        if (!this.props.canEscalate) {
            return this.setState({ showErrorAlert: true });
        }

        if (this.state.escalationReason || this.state.escalationReasonOption.value) {
            if (this.state.selectedEscalation === 1 && this.state.isAssignBySystem) {
                this.handleEscalationCsBySystem();
            }

            if (this.state.selectedEscalation === 1 && this.state.isAssignByUser) {
                this.handleEscalationCsByUser();
            }

            if (this.state.selectedEscalation === 2) {
                this.handleEscalationBV();
            }

            if (this.state.selectedEscalation === 3) {
                this.handleEscalationBE();
            }

            if (this.state.selectedEscalation === 4) {
                this.handleEscalationLead();
            }
        }
    }

    handleEscalationCsBySystem = () => {
        const updatedAt = {
            remark_escalated_id: this.state.escalationReasonOption.value.value,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataEscalationCsBySystem(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showEscalationModal: false
                }, async () => {
                    await this.getListRoom();
                    await this.handleCloseRoomChat(getContent(res));
                    this.postDataUploadChat();
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleEscalationCsByUser = () => {
        const updatedAt = {
            remark_escalated_id: this.state.escalationReasonOption.value.value,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataEscalationCsByUser(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showEscalationModal: false
                }, async () => {
                    await this.getListRoom();
                    await this.handleCloseRoomChat(getContent(res));
                    this.postDataUploadChat();
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleEscalationBV = () => {
        const updatedAt = {
            escalated_reason: this.state.escalationReason,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataEscalationBugValidator(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showEscalationModal: false
                }, () => {
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleEscalationBE = () => {
        const updatedAt = {
            remark_escalated_id: this.state.escalationReasonOption.value.value,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataEscalationBugExternal(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showEscalationModal: false
                }, () => {
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleEscalationLead = () => {
        const updatedAt = {
            escalated_reason: this.state.escalationReason,
            updated_at: this.props.data.updated_at
        }

        API_TICKET_LIST.putDataEscalationLead(updatedAt, this.props.data.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showEscalationModal: false
                }, () => {
                    setTimeout(() => {
                        this.setState({ showSuccessAlert: false });
                        this.props.history.push(ROUTER_CONSTANT.TICKET_LIST_ALL);
                    }, 1500);
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleCloseRoomChat = message => {
        const roomId = `${this.props.userDetail.client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
        const payload = {
            type: 'chat',
            message: {
                is_group: false,
                source_id: this.props.userDetail.client_id,
                destination_id: this.props.data.pic_client_id,
                identity: {
                    client_id: this.props.userDetail.client_id,
                    sign: this.props.sign
                },
                message_detail: {
                    guarantee: true,
                    type: MESSAGE_STATUS_CONSTANT.SEND,
                    message_id: uuidv4(),
                    message_model: {
                        additional_key: '',
                        content: {
                            text: message
                        },
                        created_at: moment().tz("Asia/Jakarta").valueOf(),
                        deleted_type: 0,
                        is_broadcast: 0,
                        is_encrypted: 'N',
                        is_forward: 0,
                        local_id: 'local_id',
                        message_reply_id: '',
                        room_id: roomId,
                        type_message_id: MESSAGE_TYPE_CONSTANT.TEXT,
                        vector_x: this.state.lastVectorX + 1,
                        vector_y: this.state.lastVectorY
                    }
                }
            }
        }

        const websocket = this.props.websocket;
        localStorage.setItem('closeRoomChat', 'true');
        return websocket.send(JSON.stringify(payload));
    }

    getListRoom = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true' && this.props.userDetail.client_id && this.props.data.pic_client_id) {
            const roomId = `${this.props.userDetail.client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
            return API_CHAT.getListRoom(1, 100, this.props.token)
                .then(res => {
                    const data = res.data.data.filter(item => item.room_status === 'Active');
                    const filteredData = data.find(room => room.room_id === roomId);
                    this.setState({
                        lastVectorX: filteredData.message.vector_x,
                        lastVectorY: filteredData.message.vector_y
                    })
                })
        }
    }

    postDataUploadChat = () => {
        if (localStorage.getItem('loginWithGrochatAccount') === 'true' && this.props.userDetail.client_id && this.props.data.pic_client_id) {
            const roomId = `${this.props.userDetail.client_id}_${this.props.data.ticket_no}_${this.props.data.pic_client_id}`;
            const data = {
                room_id: roomId,
                user_id: this.props.userDetail.client_id,
                ticket_id: this.props.data.id
            };
            API_TICKET_LIST.postDataUploadChat(data, this.props.token)
        }
    }

    getListEscalation = escalationType => {
        API_TICKET_LIST.getListEscalation(escalationType, 1, 100, this.props.token)
            .then(res => {
                let escalationData = getContent(res).map(escalation => ({
                    value: escalation.id,
                    label: escalation.description
                }))
                this.setState({
                    escalationReasonOption: {
                        ...this.state.escalationReasonOption,
                        data: escalationData
                    }
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleDropdown = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ showEscalationModal: false });
        }
    }

    handleOpenEscalation = data => {
        this.setState({
            selectedEscalation: data.id,
            showEscalationAction: true
        }, () => {
            if (this.state.selectedEscalation === 1 && this.state.isAssignBySystem) {
                return this.getListEscalation('escalate-by-system');
            }
            if (this.state.selectedEscalation === 1 && this.state.isAssignByUser) {
                return this.getListEscalation('escalate-by-super-user');
            }
            this.getListEscalation('escalate-bug-external');
        });
    }

    handleCloseEscalation = () => {
        this.setState({
            showEscalationAction: false,
            selectedEscalation: 0,
            escalationReason: '',
            escalationReasonOption: {
                ...this.state.escalationReasonOption,
                data: [],
                value: ''
            },
            isAssignBySystem: true,
            isAssignByUser: false
        });
    }

    handleAssignBySystem = () => {
        this.setState({
            isAssignBySystem: true,
            isAssignByUser: false,
            escalationReasonOption: {
                ...this.state.escalationReasonOption,
                data: [],
                value: ''
            },
        }, () => {
            this.getListEscalation('escalate-by-system');
        });
    }

    handleAssignByUser = () => {
        this.setState({
            isAssignBySystem: false,
            isAssignByUser: true,
            escalationReasonOption: {
                ...this.state.escalationReasonOption,
                data: [],
                value: ''
            },
        }, () => {
            this.getListEscalation('escalate-by-super-user');
        });
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleChangeEscalationReason = data => {
        this.setState({
            escalationReasonOption: {
                ...this.state.escalationReasonOption,
                value: data
            }
        })
    }

    componentDidMount() {
        this.dropdownRef = createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showEscalationModal !== this.state.showEscalationModal) {
            if (this.state.showEscalationModal) {
                document.addEventListener('click', this.handleDropdown);
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDropdown);
    }

    checkCustomerServiceAssignee = () => {
        if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO && this.props.userDetail.nexcare_id !== this.props.data.assignee_id) return false;
        return true;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_ESCALATE_UPDATE_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btnescalation" className={this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && !this.props.data.is_locked && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) && this.checkCustomerServiceAssignee() ? "bg-white text-darkblue flex justify-between items-center rounded-lg focus:outline-none w-40 py-2 px-5 mx-1" : "hidden"} onClick={() => this.setState({ showEscalationModal: !this.state.showEscalationModal })} ref={this.dropdownRef}>
                    <p>Eskalasi</p>
                    <FontAwesomeIcon icon={faChevronDown} />
                </button>
                <div className={this.state.showEscalationModal ? "relative" : "hidden"}>
                    <div className="origin-top-right absolute right-0 mt-7 z-10 w-60 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none text-gray-600">
                        {
                            this.state.escalation.map(escalation =>
                                <div className="pt-3 pl-3 pr-3 hover:bg-blue-100 cursor-pointer" key={escalation.id} id="btnescalationselect" onClick={() => this.handleOpenEscalation(escalation)}>
                                    <p className="pb-3 border-b-2 border-gray text-sm">{escalation.type}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className={this.state.showEscalationAction ? "block" : "hidden"}>
                    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 w-1/3">
                            <div className="header flex justify-between">
                                <div></div>
                                <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnescalationclose" onClick={() => this.handleCloseEscalation()} />
                            </div>
                            <div className="my-5">
                                <div className="flex items-center mb-5">
                                    <div>
                                        <img alt="Alert Warning" src={IconAlertWarning} />
                                    </div>
                                    <p className="text-2xl text-gray-600 font-medium ml-10">
                                        {this.state.selectedEscalation === 1 && "Apakah Anda yakin melakukan eskalasi ke CS Lain?"}
                                        {this.state.selectedEscalation === 2 && "Apakah Anda yakin melakukan eskalasi ke Bug Validator?"}
                                        {this.state.selectedEscalation === 3 && "Apakah Anda yakin melakukan eskalasi ke Pihak Ketiga?"}
                                        {this.state.selectedEscalation === 4 && "Apakah Anda yakin melakukan eskalasi ke CS Lead?"}
                                    </p>
                                </div>
                                <div className="bg-blue-50 rounded p-5">
                                    <label htmlFor="tmlescalationreason">Alasan <span className="text-darkred">*</span></label>
                                    {
                                        this.state.selectedEscalation === 1 || this.state.selectedEscalation === 3
                                            ? <Select
                                                id="ddsescalationreason"
                                                placeholder="Pilih Alasan *"
                                                options={this.state.escalationReasonOption.data}
                                                value={this.state.escalationReasonOption.value}
                                                onChange={this.handleChangeEscalationReason}
                                            />
                                            : <textarea id="tmlescalationreason" className="form-control resize-none h-40" placeholder="Tulis Alasan Eskalasi" name="escalationReason" value={this.state.escalationReason} onChange={this.handleChange} />
                                    }
                                    <div className={this.state.selectedEscalation === 1 ? "mt-1" : "hidden"}>
                                        <button type="button" id="btnassignbysystem" className={this.state.isAssignBySystem ? "bg-darkblue text-white rounded-l text-xs border border-darkblue focus:outline-none py-1 px-2" : "bg-transparent text-darkblue rounded-l text-xs border border-darkblue focus:outline-none py-1 px-2"} onClick={() => this.handleAssignBySystem()}>Assign CS Oleh Sistem</button>
                                        <button type="button" id="btnassignbyuser" className={this.state.isAssignByUser ? "bg-darkblue text-white rounded-r text-xs border border-darkblue focus:outline-none py-1 px-2" : "bg-transparent text-darkblue rounded-r text-xs border border-darkblue focus:outline-none py-1 px-2"} onClick={() => this.handleAssignByUser()}>Assign CS Oleh Super User</button>
                                    </div>
                                </div>
                            </div>
                            <div className="w-full flex justify-center">
                                <button type="button" id="btnno" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none w-28 py-2 mr-2" onClick={() => this.handleCloseEscalation()}>Tidak</button>
                                <button type="button" id="btnyes" className={this.state.escalationReasonOption !== '' ? "bg-darkblue rounded text-white border border-darkblue focus:outline-none w-28 py-2 ml-2" : "bg-gray-300 rounded text-white border border-gray-300 focus:outline-none w-28 py-2 ml-2"} onClick={() => this.handleEscalation()}>Ya</button>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </div>
                <Alert show={this.state.showSuccessAlert} icon="success" title="Tiket berhasil dieskalasi!" />
                <Alert show={this.state.showErrorAlert} icon="warning" title="Produk / Modul / Kategori Keluhan tidak boleh kosong!" close={() => this.setState({ showErrorAlert: false })} ok />
                <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        sign: state.authentication.sign,
        userDetail: state.authentication.userDetail,
        websocket: state.grochatWebsocket.websocket
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketEscalation));